<template>
  <div class="body">
    <img class="body-logo"
         src="~@/assets/images/logo.png"
         @click="onRouter('/')" />
    <div class="body-inputBox">
      <input class="body-inputBox-input"
             v-model="keys"
             placeholder="请输入搜索内容" />
      <div class="body-inputBox-icon"
           @click="search">
        <img src="~@/assets/images/search.png" />
      </div>
    </div>
    <div class="body-phoneBox">
      <div class="body-phoneBox-icon">
        <img src="~@/assets/images/phone.png" />
      </div>
      <div class="body-phoneBox-content">
        <div class="body-phoneBox-content-label">免费咨询热线</div>
        <div class="body-phoneBox-content-phone">025-56611801</div>
      </div>
    </div>
    <div class="body-menu"
         @click="show = true">
      <img src="~@/assets/images/menu.png" />
    </div>

    <!-- popup -->
    <van-popup v-model="show"
               position="left"
               :style="{ width: '75%', height: '100%' }">
      <div class="popup">
        <img class="popup-logo"
             src="~@/assets/images/logo.png" />
        <div class="popup-item"
             v-for="item in menus"
             :key="item.label"
             @click="onRouter(item.path)">
          <div class="popup-item-label">{{ item.label }}</div>
          <img class="popup-item-icon"
               src="~@/assets/images/menu-icon.png" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { menuList } from "@/store/menu";
export default {
  name: "AppHeader",
  components: {},
  data () {
    return {
      show: false,
      keys: "",
      menus: menuList,
    };
  },
  mounted () { },
  methods: {
    search () {
      if (this.keys == "") {
        this.$notify.error({
          title: '错误',
          message: '关键词不能为空'
        });
      } else {
        this.$router.push(
          {
            path: '/search',
            query: {
              keys: this.keys
            }
          }
        )

      }

    },
    onRouter (path) {
      this.show = false;
      this.$router.push({
        path: `${path}`
      })
    }
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
